import { render } from "./PeopleIcon.vue?vue&type=template&id=d95e0376"
const script = {}
script.render = render

export default script